import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate, useSearchParams, } from "react-router-dom"

import { Button, Text, useDisclosure } from "@chakra-ui/react"

import { createPortalSession } from "../../features/subscription/subscriptionSlice"
import { getUserObject } from "../../features/auth/authSlice"

import PlanSelectionModal from "./PlanSelectionModal"


export default function SubscriptionManager() {

    const { user, isSuccess } = useSelector((state) => state.auth)
    const { redirectUrl } = useSelector((state) => state.subscription)

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()

    const { isOpen, onOpen, onClose } = useDisclosure()

    useEffect(() => {
        dispatch(getUserObject())
    }, [])

    function getTierName() {
        switch (user.details.subscription.tier) {
            case 'free-standard':
            case 'free-restricted':
                const currentDate = new Date()

                const limitedValiditySusbcriptionExpiryDate = new Date(user.details.subscription.limitedValiditySusbcriptionExpiryDate)

                if (limitedValiditySusbcriptionExpiryDate > currentDate)
                    return `All-Country Pass (Limited validity access until ${limitedValiditySusbcriptionExpiryDate.getDate()}/${limitedValiditySusbcriptionExpiryDate.getMonth() + 1}/${limitedValiditySusbcriptionExpiryDate.getFullYear()})`

                return 'No active subscription'
            case 'premium':
                return 'All-Country Pass'
            case 'premium-courtesy':
                return 'All-Country Pass (Courtesy)'
            case 'creator':
                return 'Creator'
            case 'creator-courtesy':
                return 'Creator (Courtesy)'
            default:
                return 'Unknown (contact hello@trainlookout.com)'
        }
    }

    const renderButtonBasedOnTier = () => {
        switch (user.details.subscription.tier) {
            case 'free-standard':
            case 'free-restricted':
                return <Button onClick={onOpen} colorScheme="blue">Purchase a subscription</Button>;
            case 'premium-courtesy':
                return <Button
                    disabled
                    variant={'outline'}
                    _hover={{ bg: 'white', color: 'white.500' }}
                    _focus={{ boxShadow: 'none' }}>
                    Manage subscription
                </Button>;
            case 'premium':
                return (
                    <Button
                        variant="outline"
                        onClick={() => dispatch(createPortalSession({
                            stripeCustomerId: user.details.subscription.stripeCustomerId
                        }))}
                    >
                        Manage subscription
                    </Button>
                );
            default:
                return null;
        }
    };

    useEffect(() => {
        if (searchParams.get('paymentSuccess') === 'true' && isSuccess) {
            if (user.details.homeCountry === undefined) {
                navigate('/myjourneys?newACP=true&onboarding=true')
            } else {
                navigate('/myjourneys?newACP=true')
            }
        } else if (searchParams.get('toUpgrade') === 'true') {
            onOpen()
        }
    }, [searchParams, isSuccess])

    useEffect(() => {
        if (redirectUrl !== undefined && redirectUrl !== '')
            window.location.assign(redirectUrl)
    }, [redirectUrl])

    return (
        <>
            <Text as='u'>Your current account tier:</Text>
            <Text fontSize='sm' color='grey.500'>{getTierName()} </Text>

            {renderButtonBasedOnTier()}

            <PlanSelectionModal isOpen={isOpen} onClose={onClose} />
        </>
    )
}
